import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferManageCountQuery } from './type';

/**
 * 根据游戏 和 业务查询当前offer数量
  GET /product/offerManage/gameServiceOfferCount
  接口ID：267668645
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-267668645
 */
export const getOfferManageCount = (params: OfferManageCountQuery): AxiosPromise<number> => {
  return request({
    url: '/product/offerManage/gameServiceOfferCount',
    method: 'get',
    params
  });
};

/**
 * 根据游戏业务下载当前卖家的offer
  POST /product/offerManage/exportOffer
  接口ID：267668644
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-267668644
 */
export const postDownloadOfferUploadExcel = (data: OfferManageCountQuery): AxiosPromise => {
  return request({
    url: '/product/offerManage/exportOffer',
    method: 'post',
    data
  });
};

/**
 * offer banner 配置
 * GET /product/urlMapping/game-service/getSpuBanner
 * 接口ID：267668643
 * 参数:spuUrl
 */
export const getOfferBannerConfig = (params: { spuUrl: string }): AxiosPromise<unknown> => {
  return request({
    url: '/product/urlMapping/game-service/getSpuBanner',
    method: 'get',
    params
  });
};
